export const demandData = [
  {
    codig_demanda: 'MKTTP_REG',
    nombre_demanda: 'EL TANDIL',
  },
  {
    codig_demanda: 'MKTTP_REG',
    nombre_demanda: 'EL TANDIL',
  },
  {
    codig_demanda: 'MKTTP_NOREG',
    nombre_demanda: 'EL TANDIL',
  },
  {
    codig_demanda: 'MKTTP_NOREG',
    nombre_demanda: 'EL TANDIL',
  },
  {
    codig_demanda: 'MKTTP_NOREG',
    nombre_demanda: 'EL TANDIL',
  },
];
